import { render, staticRenderFns } from "./Reviewed.vue?vue&type=template&id=ff8fb22e"
import script from "./Reviewed.vue?vue&type=script&lang=js"
export * from "./Reviewed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports